import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const DEFAULT_CLS =
  'w-full px-4 py-3 bg-gray-800 border border-gray-700 text-white rounded-lg ' +
  'focus:ring-2 focus:ring-[#FFDD59] focus:border-transparent';

const PasswordInput = ({
  id,
  value,
  onChange,
  autoComplete,
  className,
  placeholder,
  required = false,
  'data-testid': dataTestid,
}) => {
  const [shown, setShown] = useState(false);
  const inputCls = (className || DEFAULT_CLS) + ' pr-12';
  return (
    <div className="relative">
      <input
        id={id}
        type={shown ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        placeholder={placeholder}
        required={required}
        className={inputCls}
        data-testid={dataTestid}
      />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        tabIndex={-1}
        aria-label={shown ? 'Hide password' : 'Show password'}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"
      >
        {shown ? <EyeOff size={20} /> : <Eye size={20} />}
      </button>
    </div>
  );
};

export default PasswordInput;
